import { LitElement, html, css, render } from 'lit';
import { calendar, clock, addIcon, closeAlt, provisionIcon } from '../../utilities/icons';
import { accessibility, formStyles } from '../../utilities/styles';
import { validateURL } from '../../utilities/formsUtilities';
import { formatDateString } from '../../utilities/eventUtilities';
import 'lit-flatpickr';
export class AllInRepeater extends LitElement {
    static properties = {
        name: { type: String },
        id: { type: String },
        values: { type: Array },
        subFields: { type: Array },
        zoneOptions: { type: Array },
        max: { type: Number },
        rowName: { type: String },
        count: { type: Number, state: true },
        buttonTextNew: { type: String },
        buttonText: { type: String },
        isonline: { type: Boolean },
        istouringnolocation: { type: Boolean },
        isrequired: { type: Boolean },
        hideProvisionDescription: { type: Boolean },
        openPanels: { type: Set, state: true }
    };
    constructor() {
        super();
        this.openPanels = new Set();
    }
    get showIfGroups() {
        return this.renderRoot.querySelectorAll('.input_group[data-showif]');
    }
    get requireIfGroups() {
        return this.renderRoot.querySelectorAll('.input_group[data-repeaterrequiredif]');
    }
    async connectedCallback() {
        super.connectedCallback();
        if (!this.max) {
            this.max = 999;
        }
        this.count = this.values ? this.values.length : 0;
        if (!this.buttonTextNew) {
            this.buttonTextNew = `Ychwanegu un newydd`;
        }
        if (!this.buttonText) {
            this.buttonText = `Ychwanegu un arall`;
        }
    }
    async firstUpdated() {
        this._showIfs();
        this._requireIfs();
    }
    createRenderRoot() {
        return this;
    }
    render() {
        let count = this.values ? this.values.length : 0;
        return html `\n        <input type="hidden" name="${this.name}" value="${this.values ? JSON.stringify(this.values) : '[]'}" aria-required="${this.isrequired ? 'true' : 'false'}" data-error_message="Mae angen o leiaf un enghraifft ar gyfer digwyddiad."/>\n        <div class="repeater">\n            ${this.values && this.values.length ? this.values.map((value, index) => {
            if (!value || Object.keys(value).length === 0) {
                return html ``;
            }
            let fieldID = value.id ?? '';
            if (!this.subFields || !this.subFields.length) {
                return html ``;
            }
            let markup = this.subFields.map((field) => {
                let fieldValue = value[field.name] ?? '';
                let showif = '';
                let requiredif = '';
                if (field.showif) {
                    showif = `${this.name}_${field.showif}_${index}`;
                }
                if (field.requiredif) {
                    requiredif = `${this.name}_${field.requiredif}_${index}`;
                }
                if (field.type === 'date') {
                    let oneWeekAgo = new Date();
                    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
                    if (value.allowOldDate) {
                        oneWeekAgo = new Date();
                        oneWeekAgo.setDate(); //set to one year ago
                    }
                    let input = '';
                    if (field.required) {
                        input = html `<input name="${this.name}_${field.name}_${index}" data-name="${field.name}" data-index="${index}" data-id="${fieldID}" @change=${this._handleFieldChange.bind(this)} value="${fieldValue}" aria-required="true" data-error_message="${field.error_message}" />`;
                    }
                    else {
                        input = html `<input name="${this.name}_${field.name}_${index}" data-name="${field.name}" data-index="${index}" data-id="${fieldID}" @change=${this._handleFieldChange.bind(this)} value="${fieldValue}"  data-error_message="${field.error_message}" />`;
                    }
                    return html `\n                            <div class="input_group ${showif ? 'hidden' : ''}" ?data-showif="${showif}" ?data-repeaterrequiredif="${requiredif}" data-showiftrigger=${showif} data-repeaterrequirediftrigger="${requiredif}">\n                                <label for="${this.name}_${field.name}_${index}">${field.title}${field.required ? '*' : ''}</label>\n                                <lit-flatpickr\n                                dateformat="Y-m-d"\n                                altinput="true"\n                                altformat="j F Y"\n                                mindate="${oneWeekAgo.toISOString().split('T')[0]}"\n                                defaultDate="${fieldValue}"\n                                theme="none"\n                                ><div class="datetime_wrapper">${input}${calendar}</div></lit-flatpickr>\n                            </div>\n                            `;
                }
                if (field.type === 'time') {
                    let input = '';
                    if (field.required) {
                        input = html `<input name="${this.name}_${field.name}_${index}" data-name="${field.name}" data-index="${index}" data-id="${fieldID}" @change=${this._handleFieldChange.bind(this)} value="${fieldValue}" aria-required="true" data-error_message="${field.error_message}" />`;
                    }
                    else {
                        input = html `<input name="${this.name}_${field.name}_${index}" data-name="${field.name}" data-index="${index}" data-id="${fieldID}" @change=${this._handleFieldChange.bind(this)} value="${fieldValue}"  data-error_message="${field.error_message}" />`;
                    }
                    return html `\n                            <div class="input_group ${showif ? 'hidden' : ''}" ?data-showif="${showif}" ?data-repeaterrequiredif="${requiredif}" data-showiftrigger=${showif} data-repeaterrequirediftrigger="${requiredif}">\n                                <label for="${this.name}_${field.name}_${index}">${field.title}${field.required ? '*' : ''}</label>\n                                <lit-flatpickr\n                                enabletime\n                                noCalendar\n                                dateformat="H:i"\n                                time_24hr="true"\n                                defaultDate="${fieldValue}"\n                                theme="none"\n                                ><div class="datetime_wrapper">${input}${clock}</div></lit-flatpickr>\n                            </div>\n                            `;
                }
                if (field.type === 'hidden') {
                    return html `\n                            <input type="hidden" name="${this.name}_${field.name}_${index}" data-name="${field.name}" data-index="${index}" data-id="${fieldID}" @change=${this._handleFieldChange.bind(this)}  value="${fieldValue}"/>\n                            `;
                }
                if (field.type === 'select') {
                    if (field.name === 'zoneId') {
                        // If event is ONLINE 
                        if (this.isonline) {
                            field.options = [
                                { label: `Digwyddiad ar-lein - does dim angen parthau`, value: '' }
                            ];
                            field.required = false;
                        }
                        else if (this.istouringnolocation) {
                            field.options = [
                                { label: `Digwyddiad teithio - does dim angen parthau`, value: '' }
                            ];
                            field.required = false;
                        }
                        // If event IN PERSON or HYBRID 
                        else {
                            field.required = true;
                            if (this.zoneOptions) {
                                if (!this.zoneOptions.length || this.zoneOptions.length === 1) {
                                    field.options = [
                                        { label: `Does dim parthau ar gael yn y lleoliad hwn`, value: '' }
                                    ];
                                    field.required = false;
                                }
                                else {
                                    field.options = this.zoneOptions;
                                }
                            }
                        }
                    }
                    return html `\n                            <div class="input_group">\n                                <label for="${this.name}_${field.name}_${index}">\n                                    ${field.title}${(!this.isonline && field.required ? '*' : '')}\n                                </label>\n\n                                ${field.description
                        ? html `<p class="small">${field.description}</p>` : ''}\n\n                                <select name="${this.name}_${field.name}_${index}" id="${this.name}_${field.name}_${index}" @change=${this._handleFieldChange.bind(this)} data-name="${field.name}" data-index="${index}" data-id="${fieldID}" ?aria-required=${field.required} data-error_message="${field.error_message ? field.error_message : field.label + 'is required'}">\n                                    ${(field.options ?? []).map(option => html `\n                                        <option value="${option.value}" ?selected="${option.value === fieldValue}" data-location=${option.locationId}>${option.label}</option>\n                                    `)}\n                                </select>\n                            </div>\n                            `;
                }
                if (field.type === 'provisions') {
                    let provisionArr = [];
                    field.provisions.forEach((_provision) => {
                        let icon = _provision.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                        let provisionHtml = html `\n                                    <details class="provisions">\n                                        <summary><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${_provision.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                            e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                        } }} />${_provision.title}</summary>\n                                        <div class="panel">\n                                            ${_provision.provisions.map((provision) => {
                            let checked;
                            let i = fieldValue ? fieldValue?.findIndex(p => p.standardId === provision.id) : -1;
                            let id = provision.id;
                            if (i > -1) {
                                checked = true;
                            }
                            return html `\n                                                    <div class="provision">\n                                                        <div class="input-group">\n                                                            <label for="${this.name}_${field.name}_${id}_${index}">${provision.name}</label>\n                                                            <input type="checkbox" name="${this.name}_${field.name}_${id}" value=${id} id="${this.name}_${field.name}_${id}_${index}" ?checked=${checked} @change=${this._handleFieldChange.bind(this)} data-name="${field.name}" data-index="${index}" data-provision="true" />\n                                                        </div>\n                                                        ${!this.hideProvisionDescription
                                ? html `<p class="small">${provision.description}</p>` : ''}\n                                                        <div class="input-group hidden"  data-showif="${this.name}_${field.name}_${id}_${index}" data-repeaterrequiredif="${this.name}_${field.name}_${id}_${index}" data-showiftrigger="${this.name}_${field.name}_${id}_${index}" data-repeaterrequirediftrigger="${this.name}_${field.name}_${id}_${index}" data-provisiondescription="true">\n                                                            <label for="${this.name}_${field.name}_${id}_${index}_description">Esbonio sut rydych chi\u2019n rhoi hyn ar waith</label>\n                                                            <allin-markdown-editor name="${this.name}_${field.name}_${id}_${index}_description" @blur=${this._handleFieldChange.bind(this)} id="${this.name}_${field.name}_${id}_${index}_description" data-label="${provision.name} description" data-table_label="Description" placeholder="Description" repeaterrequiredif data-provisiondescription="true" data-name="${field.name}" data-index="${index}" data-provisionid="${id}" value="${fieldValue[i]?.description}"></allin-markdown-editor>\n                                                        </div>\n                                                    </div>\n                                                `;
                        })}\n                                        </div>\n                                    </details>\n                                `;
                        provisionArr.push(provisionHtml);
                    });
                    return html `<p><strong>Pa ddarpariaethau mynediad sydd ar gael ar gyfer y digwyddiad hwn?</strong></p>${provisionArr}`;
                }
                return html `\n                            <div class="input_group ${showif ? 'hidden' : ''}" ?data-showif="${showif}" ?data-repeaterrequiredif="${requiredif}" data-showiftrigger=${showif} data-repeaterrequirediftrigger="${requiredif}">\n                                <label for="${this.name}_${field.name}_${index}">${field.title}${field.required ? '*' : ''}</label>\n                                \n                                ${field.description
                    ? html `<p class="small">${field.description}</p>` : ''}\n\n                                <input type="${field.type}" @change=${this._handleFieldChange.bind(this)} data-name="${field.name}" data-index="${index}" data-id="${fieldID}" name="${this.name}_${field.name}_${index}" value="${fieldValue}" @required=${field.required}/>\n                            </div>\n                        `;
            });
            if (count >= 10) {
                let date = value.start + ' ' + value.start_time;
                let dateStr = formatDateString(date);
                return html `\n                        <details class="repeater_details" @toggle=${this._handleToggle.bind(this)} data-index="${index}">\n                            <summary>${dateStr}</summary>\n                            <div class="panel group">\n                                ${this.openPanels.has(parseInt(index)) ? markup : ''}\n                                <button class="button_secondary" @click=${this._removeRow.bind(this)} data-index="${index}"><span aria-hidden="true">${closeAlt}</span>Tynnu</button>\n                            </div>\n                        </details>\n                    `;
            }
            return html `\n                <div class="group">\n                    ${markup}\n                    <button class="button_secondary" @click=${this._removeRow.bind(this)} data-index="${index}"><span aria-hidden="true">${closeAlt}</span>Tynnu</button>\n                </div>\n                `;
        }) : ''}\n        </div>\n        ${!this.isonline && !this.zoneOptions && !this.istouringnolocation ? html `<p class="error">Select a location to add a date</p>` : ''}\n        ${this.isonline || this.zoneOptions || this.istouringnolocation ? html `<button class="add_row button_secondary ${this.count >= this.max ? 'hidden' : ''}" @click=${this._addRow.bind(this)} ><span aria-hidden="true">${addIcon}</span>${this.buttonText && this.count ? this.buttonText : this.zoneOptions || this.isonline || this.istouringnolocation ? this.buttonTextNew : `Dewis lleoliad i ychwanegu dyddiad`}</button>` : ''}\n        \n        `;
    }
    _addRow(e) {
        e.preventDefault();
        if (this.count < this.max) {
            this.values.push({ new: true });
            this.count++;
        }
    }
    _removeRow(e) {
        e.preventDefault();
        const index = e.target.dataset.index;
        if (index !== undefined) {
            this.values.splice(index, 1);
            this.count--;
        }
    }
    _handleFieldChange(e) {
        const index = e.target.dataset.index;
        const name = e.target.dataset.name;
        const value = e.target.value;
        const fieldID = e.target.dataset.id;
        const isProvision = e.target.dataset.provision;
        const isProvisionDescription = e.target.dataset.provisiondescription;
        const provisionID = e.target.dataset.provisionid;
        if (e.target.type === 'url') {
            validateURL(e.target);
        }
        if (index !== undefined && name) {
            let newValues = [...this.values];
            if (newValues[index].new) {
                delete newValues[index].new;
            }
            if (isProvision) {
                if (!newValues[index][name]) {
                    newValues[index][name] = [];
                }
                let provisionIndex = newValues[index]['provisions'].findIndex(provision => provision.standardId == value);
                if (e.target.checked && provisionIndex === -1) {
                    newValues[index][name].push({ standardId: value, description: '' });
                }
                else {
                    newValues[index][name].splice(provisionIndex, 1);
                }
            }
            else if (isProvisionDescription) {
                let provisionIndex = newValues[index]['provisions'].findIndex(provision => provision.standardId == provisionID);
                if (provisionIndex > -1) {
                    newValues[index]['provisions'][provisionIndex]['description'] = e.target.value;
                }
            }
            else {
                newValues[index][name] = value;
            }
            if (fieldID) {
                newValues[index]['id'] = fieldID;
            }
            this.values = newValues;
        }
        this._showIfs();
        this._requireIfs();
    }
    _showIfs() {
        this.showIfGroups.forEach((group) => {
            const condition = group.dataset.showiftrigger;
            const field = this.renderRoot.querySelector(`input[name="${condition}"]`);
            if (field && field.value) {
                group.classList.remove('hidden');
            }
            else {
                group.classList.add('hidden');
            }
        });
    }
    _handleToggle(e) {
        console.log(e);
        const index = e.target.dataset.index;
        if (index !== undefined) {
            if (e.target.open) {
                this.openPanels.add(parseInt(index));
            }
            this.openPanels = new Set([...this.openPanels]);
        }
    }
    _requireIfs() {
        this.requireIfGroups.forEach((group) => {
            const condition = group.dataset.requirediftrigger;
            const field = this.renderRoot.querySelector(`input[name="${condition}"]`);
            if (field && field.value) {
                group.querySelectorAll('input, select, textarea').forEach((input) => {
                    input.setAttribute('aria-required', 'true');
                });
            }
            else {
                group.querySelectorAll('input, select, textarea').forEach((input) => {
                    input.removeAttribute('aria-required');
                });
            }
        });
    }
    static styles = [
        accessibility,
        formStyles,
        css `
            .group{
                display:none;
            }
            .hidden{
                display:none;
            }
        `
    ];
}
